const ROOM_ID_KEY = 'activeRoomId';
const ROOM_EVENT = 'apem:active-room-changed';

export function getActiveRoomId() {
    return localStorage.getItem(ROOM_ID_KEY);
}

export function setActiveRoomId(roomId) {
    localStorage.setItem(ROOM_ID_KEY, String(roomId));
    window.dispatchEvent(new Event(ROOM_EVENT));
}

export function clearActiveRoomId() {
    localStorage.removeItem(ROOM_ID_KEY);
    window.dispatchEvent(new Event(ROOM_EVENT));
}

export function onActiveRoomChanged(callback) {
    window.addEventListener(ROOM_EVENT, callback);
    window.addEventListener('storage', callback);
    return () => {
        window.removeEventListener(ROOM_EVENT, callback);
        window.removeEventListener('storage', callback);
    };
}
